"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const BulkWizardActionsContext = (0, react_1.createContext)({
    modules: [],
    pages: [],
    total: 0
});
exports.default = BulkWizardActionsContext;
